import firebase from 'firebase';
import { store as storeApi } from "./api";

export async function getCompanyFromMongo(storeId: string) {
  const store = await storeApi.get(`/${storeId}`);
  return store.data;
}

async function getCompany(idCompany: string) {

  const company = await firebase
    .firestore()
    .collection('empresas')
    .doc(idCompany)
    .get();

  const companyData = company.data();

  return companyData;
}

export default getCompany;
